/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import { Dictionary } from './types';

export const enDictionary: Dictionary = {
  landing: {
    heroTitle: "Enterprise Tricycle Fleet Management",
    heroSubtitle: "Premium tricycle leasing, structured driver payments, and integrated fleet management. Efficient, secure, and modern.",
    servicesTitle: "Our Premier Services",
    servicesSubtitle: "Comprehensive tricycle leasing and driver payment management engineered for maximum uptime and security.",
    aboutTitle: "About RUQAYYA TRANSPORT LIMITED",
    aboutText: "RUQAYYA TRANSPORT LIMITED is a premier tricycle fleet and driver leasing provider. We specialize in affordable rent-to-own tricycle models, structured driver payment plans, and digital fleet remittance solutions. Utilizing standard-setting tracking, professional-grade drivers, and a meticulously managed fleet, we power key transport networks across Nigeria.",
    statsDrivers: "Certified Drivers",
    statsVehicles: "Active Tricycles",
    statsCollections: "Completed Remittances",
    statsCoverage: "States Covered",
    whyChooseUs: "Why Leaders Choose Ruqayya",
    contactUs: "Corporate Operations Headquarters",
    footerText: "© 2026 RUQAYYA TRANSPORT LIMITED. All rights reserved. Operating with excellence.",
    driverLogin: "Access Driver Portal",
    driverRegister: "Register New Driver Profile",
    portalNotice: "Secure corporate network. Unauthorized access attempts are audited and logged."
  },
  sidebar: {
    dashboard: "Operations Console",
    fleet: "Tricycle Fleet",
    drivers: "Driver Registry",
    remittances: "Daily Remittances",
    finance: "Financial Ledger",
    vouchers: "Driver Wallets",
    auditLogs: "Audit & Security Logs",
    settings: "System Configuration"
  },
  roles: {
    driver: "Professional Driver",
    admin: "Operations Administrator",
    director: "Executive Director",
    shareholder: "Shareholder / Investor",
    public: "Public Terminal"
  },
  common: {
    search: "Search everything (e.g. Plate, Driver, Remittance ID)...",
    notifications: "Notification Stream",
    language: "Language (Yare)",
    theme: "Aesthetic Theme",
    logout: "Terminate Session",
    loading: "Synchronizing system data...",
    save: "Commit Changes",
    cancel: "Abandone Operation",
    submit: "Submit Request",
    actions: "Actions",
    status: "Status",
    date: "Effective Date",
    back: "Back to Dashboard",
    close: "Dismiss",
    confirm: "Verify Action",
    details: "System Record Details"
  },
  forms: {
    fullName: "Full Name",
    email: "Corporate Email Address",
    phone: "Active Telephone",
    licenseNo: "National Driver's License No.",
    vehicleNo: "Assigned Tricycle Plate No.",
    plateNumber: "Registration Plate Number",
    model: "Tricycle Model / Engine Size",
    capacity: "Tricycle Capacity",
    requiredField: "This validation parameter is mandatory.",
    invalidEmail: "Please provide a valid corporate email.",
    successSubmit: "Transaction request processed successfully."
  }
};

export const haDictionary: Dictionary = {
  landing: {
    heroTitle: "Keken Napep & Gudanar Da Sufuri Na Kasuwanci",
    heroSubtitle: "Tsarin ba da tukun keken napep, gudanar da kudaden direbobi, da rukunin kekuna masu dorewa.",
    servicesTitle: "Ayyukanmu Na Musamman",
    servicesSubtitle: "Cikakken tsarin gudanar da keken napep da kudaden direbobi don tabbatar da aminci da inganci mafi girma.",
    aboutTitle: "Game da RUQAYYA TRANSPORT LIMITED",
    aboutText: "RUQAYYA TRANSPORT LIMITED babban kamfani ne na gudanar da rukunin tukun keken napep. Mun ƙware a kan ba da kekunan napep ga direbobi a kan yarjejeniyar mallaka, da tsara kudaden biya na direbobi a Najeriya. Yin amfani da ingantaccen tsarin bincike da kula da kudade, muna taimakawa matasa da direbobi a fadin kasar.",
    statsDrivers: "Direbobi Masu Shaidar Kamfani",
    statsVehicles: "Kekunan Napep Masu Aiki",
    statsCollections: "Kudaden Remittance Da Aka Kammala",
    statsCoverage: "Jihohin Da Muke Aiki",
    whyChooseUs: "Dalilin Da Ya Sa Shugabanni Suke Zabar Ruqayya",
    contactUs: "Babban Ofishin Gudanarwa",
    footerText: "© 2026 RUQAYYA TRANSPORT LIMITED. An kiyaye duk haƙƙoƙi. Gudanarwa tare da kyakkyawan inganci.",
    driverLogin: "Shiga Sashen Direba",
    driverRegister: "Rijistar Sabon Direba",
    portalNotice: "Hanyar sadarwa ta kamfani mai aminci. Ana rikodin duk wani yunƙurin shiga ba tare da izini ba."
  },
  sidebar: {
    dashboard: "Gudunmawar Ayyuka",
    fleet: "Rukunin Kekuna",
    drivers: "Rijistar Direbobi",
    remittances: "Kudaden Remittance",
    finance: "Littafin Kuɗi",
    vouchers: "Asusun Direbobi",
    auditLogs: "Rikodin Tsaro & Bincike",
    settings: "Tsarin Na'ura"
  },
  roles: {
    driver: "Ƙwararren Direba",
    admin: "Mai Gudanar Da Ayyuka",
    director: "Babban Darakta",
    shareholder: "Mai Hannun Jari / Mai Zuba Jari",
    public: "Filin Jama'a"
  },
  common: {
    search: "Bincika komai (kamar Lamba, Direba, ID na Remittance)...",
    notifications: "Sanarwa Na Kamfani",
    language: "Yare (Language)",
    theme: "Tsarin Launi",
    logout: "Fita Daga Na'ura",
    loading: "Ana haɗa bayanai...",
    save: "Ajiye Canje-canje",
    cancel: "Soke Aiki",
    submit: "Tura Bukata",
    actions: "Ayyuka",
    status: "Matsayi",
    date: "Ranar Farawa",
    back: "Koma Baya",
    close: "Rufe",
    confirm: "Tabbatar Da Aiki",
    details: "Cikakken Rikodin Na'ura"
  },
  forms: {
    fullName: "Cikakken Suna",
    email: "Adireshin Imel Na Kamfani",
    phone: "Lambar Waya Mai Aiki",
    licenseNo: "Lambar Lasisin Tuki Na Ƙasa",
    vehicleNo: "Lambar Keke Da Aka Sanya",
    plateNumber: "Lambar Mota (Plate Number)",
    model: "Irin Keke / Girman Inji",
    capacity: "Ƙarfin Keke",
    requiredField: "Wannan filin yana da matuƙar mahimmanci.",
    invalidEmail: "Da fatan za a shigar da imel na kamfani mai aiki.",
    successSubmit: "An yi nasarar tura buƙatarku ta hada-hada."
  }
};
